import React from "react";
import { useParams } from "react-router-dom";
//import PersonalityEdit from "./sublist/personalitywidtedit";
import GlobalStudentPersonelQuestionsList from "../../pages/common/globalpersonelquestionlist";
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";
import Student911TopMenu from "../studentInfo/student911topmenu"

export default function InstructorStudentPersonalQuestion() {
  let { slug } = useParams();
  const { profile, setProfile } = useAuth();
  return (
    <>
    <Student911TopMenu slug={slug} activeMenu={"PersonalQuestions"} />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
          <PageNotes
              type={"Instructor"}
              pageName={"StudentPersonalQuestions"}
              studentId={slug}
              instructorId={profile.id}
            />
            <GlobalStudentPersonelQuestionsList slug={slug} />
          </div>
        </div>
      </div>
    </>
  );
}
